module.exports = __webpack_public_path__ + "static/media/pathfinder_hood.f101cf69.png";